// BannerCarousel.jsx
import React, { useState, useEffect } from "react";
import "../../Css/carrossel.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from  "../../Middleware/Firebase/firebase";

export default function BannerCarousel3() {
  const [banners, setBanners] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  // 🔧 Ajuste aqui se o status na sua base estiver diferente
  const STATUS_APROVADO = "Aproved"; // ou "Aproved" se for esse mesmo

  useEffect(() => {
    let isMounted = true;

    async function fetchBanners() {
      try {
        setLoading(true);

        const bannersRef = collection(db, "Db", "Marketing", "Banner");
        const q = query(
          bannersRef,
          where("line", "==", "line3"),
          where("status", "==", STATUS_APROVADO)
        );

        const snap = await getDocs(q);

        const data = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter((item) => {
            if (!item?.img) return false; // precisa ter imagem
            if (!item?.expired) return true;

            const now = new Date();
            const expiryDate =
              typeof item.expired?.toDate === "function"
                ? item.expired.toDate()
                : new Date(item.expired);

            return expiryDate > now;
          });

        // Pré-carregar imagens (opcional, melhora UX)
        await Promise.all(
          data.map(
            (b) =>
              new Promise((res) => {
                const img = new Image();
                img.onload = res;
                img.onerror = res;
                img.src = b.img;
              })
          )
        );

        if (isMounted) setBanners(data);
      } catch (e) {
        console.error("Erro ao buscar banners:", e);
        if (isMounted) setBanners([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchBanners();
    return () => {
      isMounted = false;
    };
  }, []);

  // 🔁 Auto play (só quando há banners)
  useEffect(() => {
    if (!banners.length) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [banners]);

  const goTo = (i) => setIndex(i);

  if (loading) {
    return (
      <div className="carousel-container">
        <div className="carousel-slide active">
          <div className="carousel-content">
            <p className="text-white/70">Carregando banners…</p>
          </div>
        </div>
      </div>
    );
  }

  if (!banners.length) {
    return (
      <div className="carousel-container">
        <div className="carousel-slide active">
          <div className="carousel-content">
            <p className="text-white/70">Sem banners aprovados no momento.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="carousel-container">
      {banners.map((banner, i) => (
        <div
          key={banner.id}
          className={`carousel-slide ${i === index ? "active" : ""}`}
          style={{ backgroundImage: `url(${banner.img})` }}
          role="img"
          aria-label={banner?.produto ?? "Banner"}
        >
          <div className="carousel-content">
            <h2>{banner?.nameProduto ?? "—"}</h2>
            <p>{banner?.Fornecedor ?? banner?.fornecedor ?? "—"}</p>
          </div>
        </div>
      ))}

      {/* Indicadores */}
      <div className="carousel-dots">
        {banners.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Ir para banner ${i + 1}`}
            aria-current={i === index ? "true" : "false"}
          />
        ))}
      </div>
    </div>
  );
}